"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const UsersAdminContext_1 = require("context/admin/UsersAdminContext");
const useSelectedUser_1 = require("context/useSelectedUser/useSelectedUser");
const useFilter_1 = __importDefault(require("hooks/useFilter"));
const TableSelectUtils_1 = require("utils/TableSelectUtils");
const ProfileType_1 = __importDefault(require("components/design-system/ProfileType"));
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const Checkbox_1 = __importDefault(require("components/shared/Checkbox"));
const FloatingAction_1 = __importDefault(require("components/shared/FloatingAction/FloatingAction"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const PaginationModule_1 = __importDefault(require("components/shared/PaginationModule/PaginationModule"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const areEqual = (prevProps, nextProps) => {
    return (0, isEqual_1.default)(prevProps, nextProps);
};
const SelectMemberTable = react_1.default.memo(({ isCluster, withJobPlacement, metadataType, additionalParams, type, customClass = '', isReadOnly = false, dispatchFilter = () => null }) => {
    const filterById = (0, useFilter_1.default)((state) => state === null || state === void 0 ? void 0 : state.filterById);
    const filter = filterById === null || filterById === void 0 ? void 0 : filterById.selectMemberFilter;
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [currentSort, setCurrentSort] = (0, react_1.useState)({
        sortColumn: 'name',
        sortDirection: 'asc'
    });
    // Bulk Selected
    const isAllSelected = (0, useSelectedUser_1.useSelectedUser)((state) => state.isAllSelected);
    const selectAllCheckbox = (0, useSelectedUser_1.useSelectedUser)((state) => state.selectAllCheckbox);
    const resetSelectedUser = (0, useSelectedUser_1.useSelectedUser)((state) => state.resetSelectedUser);
    const isSelected = (0, useSelectedUser_1.useSelectedUser)((state) => state.isSelected);
    const selectAll = (0, useSelectedUser_1.useSelectedUser)((state) => state.selectAll);
    const include = (0, useSelectedUser_1.useSelectedUser)((state) => state.include);
    const exclude = (0, useSelectedUser_1.useSelectedUser)((state) => state.exclude);
    const selectUser = (0, useSelectedUser_1.useSelectedUser)((state) => state.selectUser);
    const [isShowOnlySelected, setShowOnlySelected] = (0, react_1.useState)(false);
    const { hasMore, users, getUsersData, getAllIds, nextPage, prevPage, totalUser, total, allIds } = (0, UsersAdminContext_1.useUsersAdmin)();
    const getGroupText = (groupName) => {
        if (groupName === 'default_permission_group' ||
            groupName === 'default_cluster_group') {
            return 'Default';
        }
        else {
            return groupName;
        }
    };
    const getUserParams = () => {
        const paramUsers = {
            selectAll: selectAll,
            includes: include.map((e) => e === null || e === void 0 ? void 0 : e.id) || [],
            excludes: exclude.map((e) => e === null || e === void 0 ? void 0 : e.id) || []
        };
        const query = Object.assign(Object.assign(Object.assign(Object.assign({}, filter), { limit: 10, sortDirection: currentSort.sortDirection, sortColumn: currentSort.sortColumn }), paramUsers), (additionalParams && Object.assign({}, additionalParams)));
        if (!isShowOnlySelected) {
            query === null || query === void 0 ? true : delete query.selectAll;
            query === null || query === void 0 ? true : delete query.includes;
            query === null || query === void 0 ? true : delete query.excludes;
        }
        if (type === 'permission') {
            query.countAvailablePlacements = true;
            query.groupType = isCluster ? 'cluster_group' : 'permission_group';
            query.state = ['active', 'pending'];
            query.userState = ['active', 'pending'];
        }
        else {
            query.countAvailableUsers = true;
            query.state = ['active'];
        }
        return query;
    };
    const _getUsersData = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield getUsersData(getUserParams(), withJobPlacement, metadataType);
        setLoading(false);
    });
    const _nextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setCurrentPage(currentPage + 1);
        yield nextPage(getUserParams(), type === 'permission');
        setLoading(false);
    });
    const _prevPage = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        setCurrentPage(currentPage - 1);
        yield prevPage(getUserParams(), type === 'permission');
        setLoading(false);
    });
    const _selectAllCheckbox = () => {
        if (isShowOnlySelected)
            return resetSelection();
        return (selectAllCheckbox({
            filter: filter,
            allIds: allIds,
            totalUsers: total
        }),
            setShowOnlySelected(false));
    };
    const resetSelection = () => {
        resetSelectedUser();
        setShowOnlySelected(false);
    };
    const resetFilter = () => {
        return dispatchFilter({
            type: 'RESET',
            state: {}
        });
    };
    const _getAllIds = () => __awaiter(void 0, void 0, void 0, function* () {
        return yield getAllIds(getUserParams(), withJobPlacement);
    });
    const debounceGetUsersData = (0, react_1.useCallback)((0, debounce_1.default)(_getUsersData, 1000), [
        filter,
        currentSort
    ]);
    const debounceGetAllIds = (0, react_1.useCallback)((0, debounce_1.default)(_getAllIds, 1000), [
        filter,
        currentSort
    ]);
    (0, react_1.useEffect)(() => {
        if (!(0, TableSelectUtils_1.isFilterEmpty)(filter)) {
            debounceGetAllIds();
            setCurrentPage(1);
        }
        debounceGetUsersData();
        return (!(0, TableSelectUtils_1.isFilterEmpty)(filter) && debounceGetAllIds.cancel,
            debounceGetUsersData.cancel);
    }, [filter, currentSort]);
    const showOnlyAction = () => {
        if ((0, TableSelectUtils_1.isFilterEmpty)(filter)) {
            _getUsersData();
        }
        else {
            setLoading(true);
            resetFilter();
        }
    };
    (0, react_1.useLayoutEffect)(() => {
        showOnlyAction();
    }, [isShowOnlySelected]);
    const tableHeaders = [
        { name: 'checkbox', widthClass: 'w-[64px]', hide: false },
        {
            name: 'Name',
            widthClass: 'w-[240px]',
            hide: false,
            sort: {
                sortColumn: currentSort === null || currentSort === void 0 ? void 0 : currentSort.sortColumn,
                sortDirection: currentSort === null || currentSort === void 0 ? void 0 : currentSort.sortDirection,
                onSort: (direction) => setCurrentSort({
                    sortColumn: currentSort === null || currentSort === void 0 ? void 0 : currentSort.sortColumn,
                    sortDirection: direction
                })
            }
        },
        { name: 'Group', widthClass: 'w-[240px]' },
        { name: 'Job Title', widthClass: 'w-[240px]' },
        { name: 'Job Role', widthClass: 'w-[240px]' },
        { name: 'Job Function', widthClass: 'w-[240px]' },
        { name: 'Directorate', widthClass: 'w-[240px]' },
        { name: 'Department', widthClass: 'w-[240px]' },
        { name: 'Division', widthClass: 'w-[240px]' },
        { name: 'Region', widthClass: 'w-[240px]' },
        { name: 'City', widthClass: 'w-[240px]' },
        { name: 'Country', widthClass: 'w-[240px]' }
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `pb-[24px] ${customClass}` },
            react_1.default.createElement(Table_1.default, { headers: tableHeaders, fixedLeftCount: 2, withHideColumn: true, headerCheckbox: {
                    checked: isShowOnlySelected
                        ? true
                        : isAllSelected({ allIds: allIds, totalUsers: total }),
                    onClick: () => _selectAllCheckbox(),
                    disabled: isReadOnly
                } }, isLoading ? (react_1.default.createElement(LoadingComponent_1.default, null)) : ((users === null || users === void 0 ? void 0 : users.length) > 0 &&
                (users === null || users === void 0 ? void 0 : users.map((user, index) => {
                    const { id, name, email, groupName, jobTitle, info } = user;
                    const { jobRole, jobFunction, directorate, department, division, region, city, country } = info;
                    return (react_1.default.createElement(Table_1.default.Row, { key: id, dataCy: `table-row-${index}` },
                        react_1.default.createElement(Table_1.default.Column, { key: "0" },
                            react_1.default.createElement(Checkbox_1.default, { id: `checkbox-${id}`, name: `checkbox-${id}`, value: `checkbox-${id}`, dataCy: `checkbox-${id}`, checked: (user === null || user === void 0 ? void 0 : user.id) && isSelected(user === null || user === void 0 ? void 0 : user.id), onChange: (e) => {
                                    e.stopPropagation();
                                    selectUser(user === null || user === void 0 ? void 0 : user.id);
                                }, disabled: isReadOnly })),
                        react_1.default.createElement(Table_1.default.Column, { key: "1" },
                            react_1.default.createElement(ProfileType_1.default, { user: user, title: name, subtitle: email, size: 32, titleClassName: "typography-h400", subtitleClassName: "typography-h100" })),
                        react_1.default.createElement(Table_1.default.Column, { key: "2" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, getGroupText(groupName || '-'))),
                        react_1.default.createElement(Table_1.default.Column, { key: "3" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, jobTitle)),
                        react_1.default.createElement(Table_1.default.Column, { key: "4" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, jobRole || '-')),
                        react_1.default.createElement(Table_1.default.Column, { key: "5" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, jobFunction || '-')),
                        react_1.default.createElement(Table_1.default.Column, { key: "6" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, directorate || '-')),
                        react_1.default.createElement(Table_1.default.Column, { key: "7" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, department || '-')),
                        react_1.default.createElement(Table_1.default.Column, { key: "8" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, division || '-')),
                        react_1.default.createElement(Table_1.default.Column, { key: "9" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, region || '-')),
                        react_1.default.createElement(Table_1.default.Column, { key: "10" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, city || '-')),
                        react_1.default.createElement(Table_1.default.Column, { key: "11" },
                            react_1.default.createElement(TruncateParagraph_1.default, null, country || '-'))));
                })))),
            react_1.default.createElement("div", { className: "flex justify-end w-full mt-[12px]" },
                react_1.default.createElement(PaginationModule_1.default, { pageNumber: currentPage, handleNext: _nextPage, handlePrev: _prevPage, hasMore: hasMore }))),
        (selectAll || (include === null || include === void 0 ? void 0 : include.length) > 0) && (react_1.default.createElement(SelectedFloatingIcon, { totalSelected: selectAll ? totalUser - (exclude === null || exclude === void 0 ? void 0 : exclude.length) : include === null || include === void 0 ? void 0 : include.length, isShowOnlySelected: isShowOnlySelected, setShowOnlySelected: setShowOnlySelected, resetSelection: resetSelection, isReadOnly: isReadOnly }))));
}, areEqual);
const SelectedFloatingIcon = ({ totalSelected, isShowOnlySelected, setShowOnlySelected, resetSelection, isReadOnly }) => {
    return (react_1.default.createElement(FloatingAction_1.default, { withSidebar: true, withFooter: true, checkboxAction: {
            name: 'showOnlySelectedMember',
            id: 'showOnlySelectedMember',
            isChecked: isShowOnlySelected,
            onClick: () => setShowOnlySelected(!isShowOnlySelected)
        }, text: `Show only ${totalSelected} selected users`, cancelAction: !isReadOnly
            ? {
                onClick: resetSelection,
                text: 'Cancel selection'
            }
            : {}, dataCy: "showOnlySelectedMember" }));
};
SelectMemberTable.displayName = 'SelectMemberTable';
exports.default = SelectMemberTable;
